"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.transformMangopayUBOToDomainUBO = exports.transformDomainUBOToMangopayUBO = void 0;
const transformDateToMangopayTimestamp_1 = require("./transformDateToMangopayTimestamp");
function transformDomainUBOToMangopayUBO(ubo) {
    return {
        Id: ubo.id,
        FirstName: ubo.firstName,
        LastName: ubo.lastName,
        Address: {
            AddressLine1: ubo.address.addressLine1,
            AddressLine2: ubo.address.addressLine2,
            City: ubo.address.city,
            Country: ubo.address.countryISOCode,
            Region: ubo.address.region,
            PostalCode: ubo.address.postalCode,
        },
        Nationality: ubo.nationalityCountryISOCode,
        Birthday: (0, transformDateToMangopayTimestamp_1.transformDateToMangopayTimestamp)(ubo.birthdayAt),
        Birthplace: {
            City: ubo.birtplace.city,
            Country: ubo.birtplace.countryISOCode,
        },
    };
}
exports.transformDomainUBOToMangopayUBO = transformDomainUBOToMangopayUBO;
function transformMangopayUBOToDomainUBO(ubo, countries) {
    return {
        id: ubo.Id,
        firstName: ubo.FirstName,
        lastName: ubo.LastName,
        birthdayAt: ubo.Birthday ? new Date(ubo.Birthday * 1000) : ubo.Birthday,
        nationalityCountryISOCode: countries.find((c) => c.isoCode === ubo.Nationality?.toLowerCase()).isoCode,
        address: ubo.Address
            ? {
                addressLine1: ubo.Address.AddressLine1,
                addressLine2: ubo.Address.AddressLine2,
                city: ubo.Address.City,
                countryISOCode: countries.find((c) => c.isoCode === ubo.Address?.Country.toLowerCase()).isoCode,
                postalCode: ubo.Address.PostalCode,
                region: ubo.Address.Region,
            }
            : undefined,
        birtplace: ubo.Birthplace
            ? {
                city: ubo.Birthplace.City,
                countryISOCode: countries.find((c) => c.isoCode === ubo.Birthplace?.Country.toLowerCase()).isoCode,
            }
            : undefined,
        isActive: ubo.IsActive,
    };
}
exports.transformMangopayUBOToDomainUBO = transformMangopayUBOToDomainUBO;
//# sourceMappingURL=transformUBO.js.map